import { Controller } from "@hotwired/stimulus"

const ACTIVE_CLASSES = ["bg-orange-100", "text-orange-700", "border-orange-300"]
const INACTIVE_CLASSES = ["bg-white", "text-gray-500", "border-gray-300"]

// Syncs opens_at / closes_at fields and manages "Closed" toggle state.
export default class extends Controller {
  static targets = ["opensAt", "closesAt", "closedBtn", "closedField", "dayStartWrapper", "dayEndWrapper", "opensAtWrapper", "closesAtWrapper"]

  syncClosed(event) {
    if (event.target.value === "") return
    this.setClosedFieldValue(false)
    this.updateClosedBtn(false)
    this.validateDayStart()
  }

  setClosed() {
    const isActive = this.hasClosedBtnTarget && this.closedBtnTarget.classList.contains("bg-orange-100")

    if (isActive) {
      this.setClosedFieldValue(false)
      this.updateClosedBtn(false)
      this.showClosedFields()
    } else {
      this.clearTimePickers()
      this.moveDayEndToStartIfNeeded()
      this.setClosedFieldValue(true)
      this.updateClosedBtn(true)
      this.clearDayStartError()
      this.hideClosedFields()
    }
  }

  setClosedFieldValue(closed) {
    if (this.hasClosedFieldTarget) {
      this.closedFieldTarget.value = closed ? "1" : "0"
    }
  }

  dayStartChanged() {
    this.clearDayStartError()
  }

  removeRow(event) {
    event.preventDefault()
    event.stopPropagation()

    const destroyInput = this.element.querySelector("input[name*='[_destroy]']")
    const idInput = this.element.querySelector("input[name*='[id]']")

    if (!idInput || !idInput.value) {
      this.element.remove()
      return
    }

    if (destroyInput) {
      destroyInput.value = "1"
    }
    this.element.classList.remove("lg:flex")
    this.element.classList.add("hidden")
  }

  hideClosedFields() {
    if (this.hasDayEndWrapperTarget) this.dayEndWrapperTarget.classList.add("hidden")
    if (this.hasOpensAtWrapperTarget) this.opensAtWrapperTarget.classList.add("hidden")
    if (this.hasClosesAtWrapperTarget) this.closesAtWrapperTarget.classList.add("hidden")
  }

  showClosedFields() {
    if (this.hasDayEndWrapperTarget) this.dayEndWrapperTarget.classList.remove("hidden")
    if (this.hasOpensAtWrapperTarget) this.opensAtWrapperTarget.classList.remove("hidden")
    if (this.hasClosesAtWrapperTarget) this.closesAtWrapperTarget.classList.remove("hidden")
  }

  moveDayEndToStartIfNeeded() {
    if (!this.hasDayStartWrapperTarget || !this.hasDayEndWrapperTarget) return

    const startSelect = this.dayStartWrapperTarget.querySelector("select")
    const endSelect = this.dayEndWrapperTarget.querySelector("select")
    if (!startSelect || !endSelect) return

    if (startSelect.value === "" && endSelect.value !== "") {
      const endValue = endSelect.value

      startSelect.value = endValue
      startSelect.dispatchEvent(new Event("change", { bubbles: true }))
      this.updateCustomSelect(this.dayStartWrapperTarget, endValue)

      endSelect.value = ""
      endSelect.dispatchEvent(new Event("change", { bubbles: true }))
      this.updateCustomSelect(this.dayEndWrapperTarget, "")
    }
  }

  updateCustomSelect(wrapper, value) {
    const el = wrapper.querySelector("[data-controller~='custom-select']")
    if (!el) return
    const controller = this.application.getControllerForElementAndIdentifier(el, "custom-select")
    if (!controller) return

    if (value === "") {
      controller.clear()
    } else {
      controller.updateLabel()
      controller.highlightSelected(value)
    }
  }

  clearTimePickers() {
    this.element.querySelectorAll("[data-controller='native-time-picker']").forEach(el => {
      const controller = this.application.getControllerForElementAndIdentifier(el, "native-time-picker")
      if (controller) controller.clear()
    })
  }

  validateDayStart() {
    if (!this.hasDayStartWrapperTarget) return
    const select = this.dayStartWrapperTarget.querySelector("select")
    const trigger = this.dayStartWrapperTarget.querySelector("[data-custom-select-target='trigger']")
    if (!select || !trigger) return

    const hasTime = this.opensAtTargets.some(el => el.value !== "") ||
                    this.closesAtTargets.some(el => el.value !== "")

    if (hasTime && select.value === "") {
      trigger.classList.add("border-red-500", "ring-1", "ring-red-500")
    }
  }

  clearDayStartError() {
    if (!this.hasDayStartWrapperTarget) return
    const trigger = this.dayStartWrapperTarget.querySelector("[data-custom-select-target='trigger']")
    if (trigger) {
      trigger.classList.remove("border-red-500", "ring-1", "ring-red-500")
    }
  }

  updateClosedBtn(active) {
    if (!this.hasClosedBtnTarget) return
    const btn = this.closedBtnTarget

    if (active) {
      btn.classList.remove(...INACTIVE_CLASSES)
      btn.classList.add(...ACTIVE_CLASSES)
    } else {
      btn.classList.remove(...ACTIVE_CLASSES)
      btn.classList.add(...INACTIVE_CLASSES)
    }
  }
}
